// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n/* <style scoped lang=\"less\"> */\n/* @import '../../less/elements/color.less'; */\ndiv[data-v-56cbe42e]{\n  text-align: center;\n}\nh1[data-v-56cbe42e]{\n  font-size: 10rem;\n  /* color: @color-border; */\n}\nP[data-v-56cbe42e] {\n  margin-bottom: 0;\n}\n", ""]);
// Exports
module.exports = exports;
